import { makeAutoObservable } from 'mobx';

class OddsStore {
    oddsLastDate: string[] = [];

    constructor() {
        makeAutoObservable(this);
    }

    addLastUpdateDate(oddsLastDate: string | string[]) {
        if (oddsLastDate && oddsLastDate !== 'null' && oddsLastDate.toString().trim() !== '') {
            // 如果 oddsLastDate 是字符串，转换为数组
            const datesArray = Array.isArray(oddsLastDate) ? oddsLastDate : [oddsLastDate];
            this.oddsLastDate = Array.from(new Set([...this.oddsLastDate, ...datesArray]));
        } else {
            this.oddsLastDate = [];
        }
    }

    get uniqueOddsLastDates() {
        return Array.from(new Set(this.oddsLastDate));
    }
}

const oddsStore = new OddsStore();
export default oddsStore;
